import { File } from './file';
import { User } from './user';
import { WhiteLabel } from './white-label';

export type ProductBannerProduct = 'CPF_BACKGROUND_CHECK' | 'CPF_AUTOFILL' | 'PLACA_FIPE' | 'WHATSAPP_BOT';
export type ProductBannerCondoType = 'HOUSE' | 'APARTMENT' | 'BUSINESS' | 'OTHER';
export type ProductBannerRole = 'USER' | 'JANITOR' | 'GATEKEEPER' | 'ADMIN' | 'OWNER';

// Tópico de produto disponível no select (vem de GET product-banners/topics).
export type ProductBannerTopic = {
  value: ProductBannerProduct;
  label: string;
};

export type ProductBanner = {
  _id: string;
  title?: string;
  description?: string;
  topics: string[];
  ctaLabel?: string;
  ctaLink?: string;
  picture?: File | null;
  product: ProductBannerProduct;
  condoTypes: ProductBannerCondoType[];
  condoSizeMin?: number;
  condoSizeMax?: number | null;
  whiteLabels: WhiteLabel[] | string[];
  userTypes: ProductBannerRole[];
  startDate?: Date;
  endDate?: Date | null;
  position: number;
  isActive: boolean;
  clicksCount: number;
  createdBy?: User;
  createdAt?: Date;
  updatedBy?: User;
  updatedAt?: Date;
};

export const BuildProductBanner = (data: Partial<ProductBanner>): ProductBanner => {
  return {
    _id: typeof data === 'string' ? data : data._id || '',
    title: data.title,
    description: data.description,
    topics: data.topics || [],
    ctaLabel: data.ctaLabel,
    ctaLink: data.ctaLink,
    picture: data.picture || null,
    product: data.product as ProductBannerProduct,
    condoTypes: data.condoTypes || [],
    condoSizeMin: data.condoSizeMin,
    condoSizeMax: data.condoSizeMax,
    whiteLabels: data.whiteLabels || [],
    userTypes: data.userTypes || [],
    startDate: data.startDate ? new Date(data.startDate) : undefined,
    endDate: data.endDate ? new Date(data.endDate) : null,
    position: data.position ?? 1,
    isActive: data.isActive ?? true,
    clicksCount: data.clicksCount ?? 0,
    createdBy: data.createdBy,
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    updatedBy: data.updatedBy,
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined
  };
};
